
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Cervix_carcinoma",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Cervix_carcinoma.vue